module.exports = __webpack_public_path__ + "static/media/Empty-Recipient.004ae959.svg";